export const SITE = {
  name: 'Origem Veicular',
  /** Texto da barra fina preta, no topo de toda página. */
  topBar: 'Origem Veicular — descubra o histórico antes de comprar',
  supportEmail: 'suporte@origemveicular.com.br',
  footerClaim: 'Consulte o histórico do veículo antes de comprar.',
  legalNotice: 'LGM SOLUCOES LTDA · CNPJ 61.525.054/0001-65',
  legalName: 'LGM SOLUCOES LTDA',
  cnpj: '61.525.054/0001-65',
  social: [
    { label: 'Instagram', href: 'https://instagram.com' },
    { label: 'Facebook', href: 'https://facebook.com' },
    { label: 'YouTube', href: 'https://youtube.com' },
  ],
} as const
